jQuery(function($){

	window.addEventListener("scroll", function(){
		parallax(".blockTopHome", 10);	
	});	

	function parallax(el, speed) {
		var $slider = $(el);
		var yPos = -($(window).scrollTop() / speed);
		var coords = '0% '+ yPos + 'px';
		$($slider).css({ backgroundPosition: coords });
	}
	
	$('header').on('click', '.gotohref, a.ubermenu-target', function(){
		$('html, body').animate({
			scrollTop: $( $(this).attr('href') ).offset().top - 90
		}, 1700);
		//return false;
	});	
	
	$('.mylazy').Lazy({
		effect: "fadeIn",
		effectTime: 300,
		threshold: 0
	});		
	
	myshrink();
	
	$(".Modern-Slider").slick({
		dots:true,
		appendDots:$('.wrapSliderHome'),
		arrows:true,
		prevArrow:'<img alt="" class="prevSlid" src="/wp-content/themes/theme/images/arrow_left.svg" />',
		nextArrow:'<img alt="" class="nextSlid" src="/wp-content/themes/theme/images/arrow_left.svg" />',		
		autoplay: true,
		autoplaySpeed:9000,
		speed:700,
		slidesToShow:1,
		slidesToScroll:1,
		pauseOnHover:false,
		cssEase:'linear',
		fade:true,
	});
	
	$('.galeriaSlick').slick({
		dots: false,
		arrows:false,
		infinite: true,
		slidesToShow: 10,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 2000,
		pauseOnHover: true,
		pauseOnFocus: true,
		
		cssEase: 'ease-out',
		responsive: [
			{
				breakpoint: 1700,
				settings: {
					slidesToShow: 8,
					slidesToScroll: 1,
				}
			},		
		]
	});
});

jQuery(window).scroll(function() {
	myshrink();
});

jQuery(window).on("load",function($) {
    window.sr = ScrollReveal({ reset: false, mobile: true });
	
	sr.reveal('.myanim1', { duration: 500, scale: 0.1},100);
	sr.reveal('.myanim2', { duration: 500, scale: 0.1});		
	
	sr.reveal('.myanim3', { duration: 1000, origin: 'bottom', distance: '150px'});
	sr.reveal('.myanim4', { duration: 500, scale: 0.1},200);
	sr.reveal('.myanim5', { duration: 500, scale: 0.1, viewport:0.8},200);
	
	/**/
	var s = skrollr.init({
		forceHeight: false
	});
	if (s.isMobile()) {
		s.destroy();
	}
	
	//if(true) {
	//	jQuery('#menu-item-34').addClass('current-menu-item');
	//	jQuery('.menu-item-34').addClass('current-menu-item');		
	//}
});

function myshrink() {
	if (jQuery(document).scrollTop() > 100) {
		jQuery('.oberMenu').addClass('shrink');
		} else {
		jQuery('.oberMenu').removeClass('shrink');
	}	
}